module.exports = __webpack_public_path__ + "static/media/light-red-dot.35f18fa7.svg";